export class ItemFormulaGeral {
  id: number;
  idProduto: number;
  produto: string;
  formula: string;
}
